import React from 'react'

import { SubHeader } from 'components'

const Trails = () => (
  <SubHeader
    breadcrumb={[
      {
        text: 'Home',
        href: '/',
      },
      {
        text: 'Trails',
      },
    ]}
    heading="Trails"
  />
)

export default Trails
